import React from 'react'
import { Card, Flex, Label, Link, InfoIcon } from '@fareye/ui'

interface IOverviewPerformanceCards {
  label: string
  url?: string
  count?: string
  style?: React.CSSProperties
  urlLabel?: string
  showCount?: boolean
  description?: string
}
export default function OverviewPerformanceCards({
  label,
  url,
  count,
  style,
  urlLabel,
  showCount = true,
  description
}: IOverviewPerformanceCards) {
  return (
    <Card style={{ ...style }}>
      <Flex column>
        <Flex alignItemsCenter justifyContentSpaceBetween>
          <Label style={{ padding: '9px 0' }}>
            {label}
            {description && (
              <InfoIcon
                style={{ marginLeft: 5, marginRight: 5, cursor: 'pointer' }}
                title={description}
              />
            )}
          </Label>
          {url && <Link to={url}> {urlLabel}</Link>}
        </Flex>
        {showCount && <Label variant="h3">{count}</Label>}
      </Flex>
    </Card>
  )
}
